import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { RadioElement, getDefaultCargoRequestValue, NOT_RESET_FIELDS, displayValue } from './common';
import { Checkbox, MenuItem, SelectField, TextField } from 'material-ui';

import CollapseCustomizable from 'components/common/CollapseCustomizable';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import { PACKING_TYPES } from 'constants/packingType';
import helpers from 'helpers';

function Packed({
    updateCargoOrder,
    numberOrderTable,
    cargoPackingIndex,
    cargoOrder,
    cargoPacking,
    canCheck = false,
}) {
    const [disabledAll, setDisableAll] = useState(false);

    useEffect(() => {
        if (cargoPacking.category !== 'packed') {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');

            NOT_RESET_FIELDS.forEach((field) => {
                metaPack[field] = cargoPacking.pack[field];
            });

            setDisableAll(true);
            modifyField('pack', metaPack);
        } else {
            setDisableAll(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    /**
     * 
     * @param {string} fieldPath field path 
     * @param {any} value 
     */
    const modifyField = (fieldPath, value) => {
        const newCargoOrder = _.cloneDeep(cargoOrder);
        _.set(newCargoOrder.cargo[cargoPackingIndex].packing, fieldPath, value);
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    const changeStackable = () => {
        const newStackableValue = !cargoPacking.pack.stackable.value;

        const newCargoOrder = _.cloneDeep(cargoOrder);

        newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable.value = newStackableValue;

        if (!newStackableValue) {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');

            newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable = metaPack.stackable;
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return (<div><CollapseCustomizable 
        _key='packed'
        head={
            <RadioElement 
                value='packed' 
                checkedValue={cargoPacking.category}
                disabled={!canCheck}
                onCheck={() => modifyField('category', 'packed')}
                label='packed' 
                _key='packed' 
            />
        }
        headStyle={{ borderBottom: '1px solid #E0E0E0' }}
        body={
            <React.Fragment>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <SelectField 
                            value={cargoPacking.pack.name || ''}
                            hintText='Packing type'
                            floatingLabelText='Packing type'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={(_e, _i, v) => modifyField('pack.name', v)}
                        >   
                            {
                                PACKING_TYPES.map((item, index) => (
                                    <MenuItem 
                                        key={`${item}_${index}`}
                                        value={item}
                                        primaryText={item}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.bundleLength.value',
                                disabledAll,
                            )}
                            hintText='Length, mm'
                            floatingLabelText='Length, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e => 
                                modifyField('pack.bundleLength.value', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.bundleBeam.value',
                                disabledAll,
                            )}
                            hintText='Width, mm'
                            floatingLabelText='Width, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e => 
                                modifyField('pack.bundleBeam.value', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.bundleHeight.value',
                                disabledAll,
                            )}
                            hintText='Height, mm'
                            floatingLabelText='Height, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e => 
                                modifyField('pack.bundleHeight.value', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.bundlesQuantity',
                                disabledAll,
                            )}
                            hintText='Quantity'
                            floatingLabelText='Quantity'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.bundlesQuantity', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Checkbox 
                            label='Stackable'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.value',
                                disabledAll,
                            )}
                            onCheck={changeStackable}
                            disabled={disabledAll}
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.stackable.tiers',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            hintText='Tiers'
                            floatingLabelText='Tiers'
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => 
                                modifyField('pack.stackable.tiers', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Checkbox 
                            label='Inter-tier dunn...'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.dunnaging',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            onCheck={
                                () => modifyField('pack.stackable.dunnaging', !cargoPacking.pack.stackable.dunnaging)
                            }
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <Checkbox 
                            label='Nested'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.nested',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            onCheck={
                                () => modifyField('pack.stackable.nested', !cargoPacking.pack.stackable.nested)
                            }
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                </div>     
            </React.Fragment>
        }
    />
    </div>);
}

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        const cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
        return {
            cargoOrder,
            cargoPacking,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(Packed));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packed.jsx